import { type Flow } from '../types';

type NextPathOptions = 'stop_at' | 'stop_before';
type StopPath = { option: NextPathOptions; path: string } | string;

export async function findNextPaths<S>(
  flow: Flow<S>,
  state: S,
  currentPath: string,
  stopPath?: StopPath
): Promise<string[]> {
  const currentStep = flow[currentPath];
  const stopPathOptions: { option: NextPathOptions; path: string } | undefined =
    stopPath
      ? typeof stopPath === 'string'
        ? { option: 'stop_at', path: stopPath }
        : stopPath
      : undefined;

  if (stopPathOptions && stopPathOptions.path === currentPath) {
    return stopPathOptions.option === 'stop_at' ? [currentPath] : [];
  }

  const nextPath = await currentStep.next(state);
  const completed = await currentStep.completed(state);
  return completed
    ? [
        currentPath,
        ...(await findNextPaths(flow, state, nextPath, stopPathOptions)),
      ]
    : [currentPath];
}
